export default __webpack_public_path__ + "media/images/alert_badge.png";